export const LANGUAGES = {
  JA_HRKT: 1,
  JA_ROMA: 2,
  KO: 3,
  ZH_HANT: 4,
  FR: 5,
  DE: 6,
  ES: 7,
  IT: 8,
  EN: 9,
  CS: 10,
  JA: 11,
  ZH_HANS: 12,
  PT_BR: 13,
  ES_419: 14,
} as const;
